export default "__VITE_ASSET__TVx7HVBS__";